import { render, staticRenderFns } from "./superdocument-add-or-update.vue?vue&type=template&id=c0a21cf0&scoped=true"
import script from "./superdocument-add-or-update.vue?vue&type=script&lang=js"
export * from "./superdocument-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./superdocument-add-or-update.vue?vue&type=style&index=0&id=c0a21cf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0a21cf0",
  null
  
)

export default component.exports